// extracted by mini-css-extract-plugin
module.exports = {"afterText":"e_4","cards":"e_5","advTitle":"e_6","formTitle":"e_7","advButton":"e_8","formContainer":"e_9","formContainerSubmitting":"e_-","formTextarea":"e_ab","formButton":"e_bb"};